document.addEventListener('DOMContentLoaded', () => {
  const mmButton = document.querySelector('[data-mm-toggle]');
  const subnav = document.querySelector('[data-mobile-subnav]');

  if (!mmButton || !subnav) return;

  const observer = new MutationObserver(() => {
    if (mmButton.dataset.mmToggle === 'close') {
      subnav.classList.add('hidden');
    } else {
      subnav.classList.remove('hidden');
    }
  });

  observer.observe(mmButton, {
    attributes: true,
    attributeFilter: ['data-mm-toggle']
  });
});